<template>
  <div>
    <b-row class="pt-1">
      <b-col cols="6">
        <b-card>
          <template #header>
            <b-row class="pt-1">
              <b-col cols="10" class="d-flex">
                <b-link :to="{name: 'Appearance'}">
                  <h4 class="m-dir-2">
                    {{label.pages.Appearance}}
                  </h4>
                </b-link>
                /
                <h4 class="m-dirR-2">
                  {{ $route.meta.label }}
                </h4>
              </b-col>
              <b-col cols="2" class="dir-text-start">
                <a
                    @click="$router.go(-1)"
                    v-b-tooltip.noninteractive.hover.right
                    :title="label.pages.previousPage"
                    class="mouse-change pe-3"
                >
                  <b-icon
                      icon="arrow-left-square-fill"
                      variant="ps-base"
                      scale="1.2"
                      class="align-middle ms-1"
                  />
                </a>
              </b-col>
            </b-row>
          </template>
          <b-card-body>
              <b-row class="mt-3 mb-4" v-show="contentLanguageAccess == 1">
                <b-col class="text-start" cols="3">
                  <label for="language" class="ps_label">
                    {{label.pages.contentLanguage}}
                  </label>
                </b-col>
                <b-col cols="9">
                  <v-select
                    input-id="language"
                    :options="languages"
                    v-model="selectedLanguage"
                    :reduce="group => group.id"
                    :clearable="false"
                    size="sm"
                    class="ps_select"
                    @input="setLanguage"
                  >
                  </v-select>
                </b-col>
              </b-row>
              <div class="accordion">
                <b-card
                    v-for="menu in items"
                    :key="menu.id"
                    class="mb-1"
                >
                  <b-card-header header-tag="header" class="p-1">
                    <b-row>
                      <b-col sm="1">
                        <button
                            @click="addRoot(menu)"
                            :id="'subMenuTlp-' + menu.id"
                        >
                          <b-icon icon="plus-square-fill" scale="1.1" variant="success"></b-icon>
                        </button>
                        <b-tooltip
                          boundary="#app"
                          noninteractive
                          triggers="hover"
                          :target="'subMenuTlp-' + menu.id"
                        >
                          {{ label.pages.subMenu }}
                        </b-tooltip>
                      </b-col>
                      <b-col sm="11">
                        <b-row v-b-toggle="'accordion-' + menu.id" class="p-0 m-0">
                          <b-col class="m-0 p-0" sm="11">
                            <p class="fs10 fw2 text-center mb-0 py-1"> {{ menu.text }} </p>
                          </b-col>
                          <b-col class="when-closed m-0 p-0 align-self-center" sm="1">
                            <b-icon icon="caret-down-fill" scale="0.9"></b-icon>
                          </b-col>
                          <b-col class="when-open m-0 p-0 align-self-center" sm="1">
                            <b-icon icon="caret-up-fill" scale="0.9"></b-icon>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                  </b-card-header>
                  <b-collapse :id="'accordion-' + menu.id" visible accordion="menu-accordion">
                    <b-card-body>
                      <treeselect
                          :dir="label.direction"
                          class="dir-text-end fs-normal tree"
                          :options="menu.children"
                          :placeholder="label.pages.searchTitle"
                          :normalizer="normalizer"
                          :max-height='290'
                          :show-count="true"
                          openDirection="bottom"
                          alwaysOpen
                          :default-expand-level="5"
                      >
                        <label slot="option-label"
                               slot-scope="{ node, shouldShowCount, count, labelClassName, countClassName }">
                          <span class="px-2 pb-1">{{ node.label }} </span>
                          <span v-if="shouldShowCount" :class="countClassName">
                            <button
                                class="text-dark fs9"
                                :id="'numberSubMenuTlp-' + node.id"
                            >
                              ({{ count }})
                            </button>
                            <b-tooltip
                              boundary="#app"
                              noninteractive
                              triggers="hover"
                              :target="'numberSubMenuTlp-' + node.id"
                            >
                              {{ label.pages.numberSubMenu }}
                            </b-tooltip>
                          </span>
                          <button
                              @click="edit(node)"
                              :id="'editSubMenuTlp-' + node.id"
                          >
                            <b-icon icon="dash-square-fill" scale="1.1" variant="ps-edit-icon"></b-icon>
                          </button>
                          <b-tooltip
                            boundary="#app"
                            noninteractive
                            triggers="hover"
                            :target="'editSubMenuTlp-' + node.id"
                          >
                            {{ label.buttons.edit }}
                          </b-tooltip>
                          <button
                              @click="delConfirm(node)"
                              :id="'deleteSubMenuTlp-' + node.id"
                          >
                            <b-icon icon="x-square-fill" scale="1.1" variant="ps-delete-icon"></b-icon>
                          </button>
                          <b-tooltip
                            boundary="#app"
                            noninteractive
                            triggers="hover"
                            :target="'deleteSubMenuTlp-' + node.id"
                          >
                            {{ label.buttons.delete }}
                          </b-tooltip>
                          <button
                              @click="add(node)"
                              :id="'addSubMenuBtnTlp-' + node.id"
                          >
                            <b-icon icon="plus-square-fill" scale="1.1" variant="ps-add-icon"></b-icon>
                          </button>
                          <b-tooltip
                            boundary="#app"
                            noninteractive
                            triggers="hover"
                            :target="'addSubMenuBtnTlp-' + node.id"
                          >
                            {{ label.buttons.addSubMenu }}
                          </b-tooltip>
                        </label>
                      </treeselect>
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </div>

          </b-card-body>
        </b-card>
      </b-col>
      <b-col cols="6">
        <b-card>
          <div>
            <b-card-header>
              <b-row class="pt-1">
                <b-col cols="12" class="text-center">
                  <h3 class="me-2">
                    <small v-if="formCheck === null">
                      {{ label.captions.chooseMenu}}
                    </small>
                    <small v-if="formCheck === 'add'">
                      {{label.pages.recordMenu}}
                      «{{ formTitle }}»
                    </small>
                    <small v-if="formCheck === 'edit'">
                      {{label.pages.editMenu}}
                      «{{ formTitle }}»
                    </small>
                  </h3>
                </b-col>
              </b-row>
            </b-card-header>
            <b-card-body>
              <b-card-text :dir="label.direction">
                <div v-if="formCheck === null">
                  <b-row class="mt-3 text-center">
                      <h5 class="text-ps-danger">
                        {{label.pages.Menu}}
                      </h5>
                  </b-row>
                </div>
                <div v-if="formCheck === 'add'">
                  <b-row class="my-3">
                    <b-col sm="3">
                      <label for="title" class="ps_label">{{label.pages.title}}</label><span class="ps_label_star">*</span>
                    </b-col>
                    <b-col sm="9">
                      <b-form-input id="title" size="sm" v-model="form.title"/>
                    </b-col>
                  </b-row>
                  <b-row class="my-3">
                    <b-col sm="3">
                      <label for="link" class="ps_label">{{label.pages.link}}</label>
                    </b-col>
                    <b-col sm="9">
                      <b-form-input id="link" size="sm" dir="ltr" v-model="form.link"/>
                    </b-col>
                  </b-row>
                  <b-row class="my-3">
                    <b-col sm="3">
                      <label for="priority" class="ps_label">{{label.pages.priorityShow}}</label>
                    </b-col>
                    <b-col sm="9">
                      <b-form-input id="priority" type="number" size="sm" v-model="form.priority" value='1'/>
                    </b-col>
                  </b-row>
                  <b-row class="my-3">
                    <b-col sm="3">
                      <label for="status" class="ps_label">{{label.pages.status}}</label>
                    </b-col>
                    <b-col sm="9">
                      <label class="ps-switch">
                        <input type="checkbox" v-model="form.status">
                        <span class="slider round"></span>
                      </label>
                    </b-col>
                  </b-row>
                </div>
                <div v-if="formCheck === 'edit'">
                  <b-row class="my-3">
                    <b-col sm="3">
                      <label for="title" class="ps_label">{{label.pages.title}}</label><span class="ps_label_star">*</span>
                    </b-col>
                    <b-col sm="9">
                      <b-form-input id="title" size="sm" v-model="form.title"/>
                    </b-col>
                  </b-row>
                  <b-row class="my-3">
                    <b-col sm="3">
                      <label for="link" class="ps_label">{{label.pages.link}}</label>
                    </b-col>
                    <b-col sm="9">
                      <b-form-input id="link" size="sm" dir="ltr" v-model="form.link"/>
                    </b-col>
                  </b-row>
                  <b-row class="my-3">
                    <b-col sm="3">
                      <label for="priority" class="ps_label"> {{label.pages.priorityShow}}</label>
                    </b-col>
                    <b-col sm="9">
                      <b-form-input id="priority" type="number" size="sm" v-model="form.priority" value='1'/>
                    </b-col>
                  </b-row>
                  <b-row class="my-3">
                    <b-col sm="3">
                      <label for="status" class="ps_label">{{label.pages.status}}</label>
                    </b-col>
                    <b-col sm="9">
                      <label class="ps-switch">
                        <input type="checkbox" v-model="form.status">
                        <span class="slider round"></span>
                      </label>
                    </b-col>
                  </b-row>
                </div>
              </b-card-text>
            </b-card-body>
            <b-card-footer>
              <div class="d-flex justify-content-end" v-if="formCheck === 'add'">
                <b-button
                    v-if="!loadingBtn"
                    variant="ps-success"
                    size="sm"
                    class="mx-1"
                    @click="addMenu"
                >
                  <b-icon icon="check2-circle" class="ms-1"/>
                  {{label.buttons.submit}}
                </b-button>
                <b-button
                    v-else
                    disabled
                    variant="ps-success"
                    size="sm"
                    class="mx-1"
                >
                  <b-spinner small></b-spinner>
                </b-button>
              </div>
              <div class="d-flex justify-content-end" v-if="formCheck === 'edit'">
                <b-button
                    variant="ps-warning"
                    size="sm"
                    class="mx-1"
                    @click="editMenu"
                >
                  <b-icon icon="check2-circle" class="ms-1"/>
                  {{label.buttons.saveChanges}}
                </b-button>
              </div>
            </b-card-footer>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <!-- Delete Confirm Modal -->
    <b-modal
        :dir="label.direction"
        v-model="delModal"
        hide-header
        centered
    >
      <b-container fluid>
        <b-row class="mt-2">
          <p class="fs10 text-center lh1 mb-0">
            {{ label.captions.deleteConfirm}}
            <br/>
            <strong>« {{ delTitle }} »</strong>
          </p>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
                variant="ps-secondary"
                size="sm"
                class="mx-1"
                @click="delModal=false"
            >
            {{label.buttons.cancel}}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
                v-if="!loadingBtn"
                variant="ps-danger"
                size="sm"
                class="mx-1"
                @click="deleteMenu"
            >
            {{label.buttons.deleteConfirm}}
            </b-button>
            <b-button
                v-else
                disabled
                variant="ps-danger"
                size="sm"
                class="mx-1"
            >
              <b-spinner small></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import Treeselect from "@riophae/vue-treeselect";
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import { dropZone } from "@/components/dropZone";
import label from "@/plugins/StaticLabels.js";
import { contentLanguage } from "@/plugins/ContentLangMixin.js";

export default {
  name: 'MenusManagement',
  mixins: [dropZone, contentLanguage],
  components: {
    Treeselect,
  },
  data() {
    return {
      formCheck: null,
      formId: null,
      formTitle: null,
      label,
      form: {
        title: null,
        link: null,
        priority: null,
        status: true
      },
      delModal: false,
      delId: null,
      delTitle: null,
    }
  },
  computed: {
    ...mapGetters({
      postCheck: 'postCheck',
      items: 'baseX/menus',
      menu: 'baseX/menu',
      loadingBtn: 'loadingBtn',
    }),
  },
  watch: {
    postCheck() {
      if (this.postCheck === true) {
        this.delModal = false;
        this.reloadFields();
        this.reloadContent();
      }
    },
    menu() {
      this.getMenu()
    }
  },
  methods: {
    normalizer(node) {
      return {
        id: node.id,
        label: node.text,
        children: node.children,
      }
    },
    addRoot(item) {
      this.reloadFields();
      this.formCheck = 'add';
      this.formTitle = item.text;
      this.formId = item.id;
    },
    add(item) {
      this.reloadFields();
      this.formCheck = 'add';
      this.formTitle = item.label;
      this.formId = item.id;
    },
    addMenu() {
      this.$store.commit("setLoadingBtn", true);
      if (this.form.title) {
        let formData = new FormData();
        formData.append('ParentId', this.formId);
        formData.append('Title', this.form.title);
        if (this.form.link) {
          if (this.form.link.indexOf("/") === 0 || this.form.link.indexOf("https") === 0 || this.form.link.indexOf("http") === 0 || this.form.link.indexOf("") === 0) {
            formData.append('Link', this.form.link);
          } else if (this.form.link.indexOf("/") !== 0) {
            formData.append('Link', "/" + this.form.link);
          }
        }
        if (this.form.priority) {
          formData.append('Priority', this.form.priority);
        }
        if (this.form.status) {
          formData.append('IsConfirm', this.form.status);
        }
        formData.append('languageId', this.selectedLanguage);
        this.$store.dispatch('baseX/addMenu', formData);
      } else {
        this.$store.commit('setError', 'پر کردن همه موارد ستاره دار الزامی است')
      }
      this.$store.commit("setLoadingBtn", false);
    },
    edit(item) {
      this.formCheck = 'edit';
      this.formTitle = item.label;
      this.formId = item.id;
      this.$store.dispatch('baseX/getMenuById', this.formId);
    },
    getMenu() {
      this.form.title = this.menu.title;
      this.form.link = this.menu.link;
      this.form.priority = this.menu.priority;
      this.form.status = this.menu.isConfirm;
    },
    editMenu() {
      this.$store.commit("setLoadingBtn", true);
      if (this.form.title != null) {
        let formData = new FormData();
        if (this.form.title != null) {
          formData.append('Title', this.form.title);
        }
        if (this.form.link != null) {
          if (this.form.link.indexOf("/") === 0 || this.form.link.indexOf("https") === 0 || this.form.link.indexOf("http") === 0 || this.form.link.indexOf("") === 0) {
            formData.append('Link', this.form.link);
          } else if (this.form.link.indexOf("/") !== 0) {
            formData.append('Link', "/" + this.form.link);
          }
        }
        if (this.form.priority != null) {
          formData.append('Priority', this.form.priority);
        }
        if (this.form.status != null) {
          formData.append('IsConfirm', this.form.status);
        }
        formData.append('languageId', this.selectedLanguage);
        const values = {
          id: this.formId,
          value: formData
        };
        this.$store.dispatch('baseX/editMenu', values);
      } else {
        this.$store.commit('setError', 'پر کردن همه موارد ستاره دار الزامی است')
      }
      this.$store.commit("setLoadingBtn", false);
    },
    delConfirm(item) {
      this.delId = item.id
      this.delTitle = item.label;
      this.delModal = true;
    },
    deleteMenu() {
      this.$store.commit("setLoadingBtn", true);
      this.$store.dispatch('baseX/deleteMenu', this.delId);
    },
    reloadFields() {
      this.formCheck= null,
      this.formId= null,
      this.formTitle= null,
      this.form= {
        title: null,
        link: null,
        priority: null,
        status: true
      },
      this.delModal= false,
      this.delId= null,
      this.delTitle= null,
      this.file= null
    },
    reloadContent() {
      this.$store.dispatch('baseX/getMenus', this.selectedLanguage);
    },
  },
  mounted() {
    this.reloadContent();
  },
}
</script>
<style scoped>
.bt {
  width: 100%
}

.tree {
  margin: 20px 0 300px 0;
}

.vue-treeselect__option-arrow {
  width: 8px !important;
  height: 8px !important;
}

.vue-treeselect__option span {
  font-size: 10pt !important;
}

.collapsed > .when-open,
.not-collapsed > .when-closed {
  display: none;
}

</style>
